/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { FreelancerComplianceFileEntryResource } from './';
import {
    FreelancerComplianceFileEntryResourceFromJSON,
    FreelancerComplianceFileEntryResourceFromJSONTyped,
    FreelancerComplianceFileEntryResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FreelancerComplianceFileResource
 */
export interface FreelancerComplianceFileResource {
    /**
     * 
     * @type {string}
     * @memberof FreelancerComplianceFileResource
     */
    id: string;
    /**
     * 
     * @type {Array<FreelancerComplianceFileEntryResource>}
     * @memberof FreelancerComplianceFileResource
     */
    files: Array<FreelancerComplianceFileEntryResource>;
}

/**
 * Check if a given object implements the FreelancerComplianceFileResource interface.
 */
export function instanceOfFreelancerComplianceFileResource(value: object): value is FreelancerComplianceFileResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('files' in value) || value['files'] === undefined) return false;
    return true;
}

export function FreelancerComplianceFileResourceFromJSON(json: any): FreelancerComplianceFileResource {
    return FreelancerComplianceFileResourceFromJSONTyped(json, false);
}

export function FreelancerComplianceFileResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerComplianceFileResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'files': ((json['files'] as Array<any>).map(FreelancerComplianceFileEntryResourceFromJSON)),
    };
}

export function FreelancerComplianceFileResourceToJSON(value?: FreelancerComplianceFileResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'files': ((value['files'] as Array<any>).map((v) => FreelancerComplianceFileEntryResourceToJSON(v))),
    };
}

